import { GraphData } from '@/hooks/useTaxonomyRun'

// The parent passes one of these two shapes depending on what's hovered.
export type NodeHover = {
  kind: 'node'
  node: GraphData['nodes'][0]
  edgeCount: number   // how many edges touch this node
  x: number
  y: number
}

export type EdgeHover = {
  kind: 'edge'
  sourceNode: GraphData['nodes'][0]
  targetNode: GraphData['nodes'][0]
  weight: number
  x: number
  y: number
}

export type PopoverData = NodeHover | EdgeHover

interface GraphPopoverProps {
  popover: PopoverData | null
}

export function GraphPopover({ popover }: GraphPopoverProps) {
  if (!popover) return null

  return (
    // Absolutely positioned. Parent container must be position: relative.
    // Offset slightly so the popover doesn't sit right on the cursor.
    <div
      className="absolute z-10 bg-white border border-gray-200 rounded-lg shadow-lg p-3 pointer-events-none text-sm"
      style={{
        left: popover.x + 12,
        top:  popover.y - 10,
        maxWidth: 220,
      }}
    >
      {popover.kind === 'node' ? (
        <>
          <p className="font-mono font-semibold text-blue-700">{popover.node.name}</p>
          <p className="text-gray-600 mt-0.5">{popover.node.description}</p>
          <p className="text-gray-400 text-xs mt-0.5">e.g. {popover.node.example}</p>
          <p className="text-gray-500 text-xs mt-1">
            Intent: <span className="font-medium text-gray-700">{popover.node.intent_name}</span>
          </p>
          <p className="text-gray-500 text-xs">
            Connections: <span className="font-medium text-gray-700">{popover.edgeCount}</span>
          </p>
        </>
      ) : (
        <>
          <p className="font-semibold text-gray-800">Relationship</p>
          <p className="text-gray-600 mt-0.5">
            <span className="font-mono text-blue-700">{popover.sourceNode.name}</span>
            <span className="text-gray-400 mx-1.5">↔</span>
            <span className="font-mono text-blue-700">{popover.targetNode.name}</span>
          </p>
          <p className="text-gray-500 text-xs mt-1">
            Weight: <span className="font-medium text-gray-700">{popover.weight.toFixed(2)}</span>
          </p>
        </>
      )}
    </div>
  )
}
